import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MembershipStatus } from '../../models/membership-enums';


interface IdListOption {
  id: number;
  name: string;
}


@Component({
  selector: 'app-id-list-selector',
  templateUrl: './id-list-selector.component.html',
  styleUrls: ['./id-list-selector.component.css']
})
export class IdListSelectorComponent {
  @Input()
  idList: number[];

  @Input()
  unsavedChanges: boolean;
  @Output()
  unsavedChangesChange = new EventEmitter<boolean>();

  @Input()
  options: IdListOption[];

  @Input()
  title: string;

  @Input()
  optionsEmptyMessage: string;

  constructor() {}

  public optionSelected(option: IdListOption) {
    return this.idList.includes(option.id);
  }

  public allOptionsAreSelected() {
    for (const option of this.options) {
      if (!this.optionSelected(option)) { return false; }
    }
    return true;
  }

  public toggleOption(option: IdListOption) {
    if (this.optionSelected(option)) {
      this.idList.splice(this.idList.indexOf(option.id), 1);
    } else {
      this.idList.push(option.id);
    }
    this.unsavedChangesChange.emit(true);
  }

  public setNoOptionsSelected() {
    this.idList.splice(0, this.idList.length);
    this.unsavedChangesChange.emit(true);
  }

  public setAllOptionsSelected() {
    for (const option of this.options) {
      if (!this.optionSelected(option)) {
        this.idList.push(option.id);
      }
    }
    this.unsavedChangesChange.emit(true);
  }

  protected readonly MembershipStatus = MembershipStatus;
}
